var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { loadResourcesUtils } from "@ane/core/lib/utils";
import { combineEpics } from "redux-observable";
import ExperimentationGroupResourceV2 from "@ane/exp-data/lib/resources/expapiunified/ExperimentationGroup.resource";
import DataplaneResource from "../../../resources/DataplaneResources.js";
import { AnalysisConfigRouteUtils } from "@ane/exp-data/lib/routes/AnalysisConfigRoute.utils";
import NavigationService from "@ane/core/lib/services/NavigationService";
import AssignmentUnitsResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
import AnalysisTemplateResource from "../../../resources/AnalysisTemplateResource.js";
const prefix = "ANALYSIS_CONFIG_EDIT";
const experimentationGroupsPrefix = `${prefix}/EXPERIMENTATION_GROUPS`;
const assignmentUnitsPrefix = `${prefix}/ASSIGNMENT_UNITS`;
const analysisTemplatesPrefix = `${prefix}/ANALYSIS_TEMPLATES`;
const rootExperimentationGroupPrefix = `${prefix}/ROOT_EXPERIMENTATION_GROUP`;
const analysisRulePrefix = `${prefix}/ANALYSIS_RULE`;
const editAnalysisRulePrefix = `${prefix}/EDIT_ANALYSIS_RULE`;
const CLEAR_ANALYSIS_RULE_EDIT_ACTION = `${prefix}/CLEAR_REQUEST';`;
const clearEditAnalysisRule = () => {
  return {
    type: CLEAR_ANALYSIS_RULE_EDIT_ACTION
  };
};
const loadExperimentationGroupsEpicReducerArgs = {
  actionPrefix: experimentationGroupsPrefix,
  reduxKeyNested: () => ["experimentationGroups"],
  loadResource: (workspaceId) => {
    return ExperimentationGroupResourceV2.getExperimentationGroups(workspaceId);
  },
  onCompleteSuccess: (resourceResult, inputPayload) => {
    return resourceResult.value.map((eg) => __spreadProps(__spreadValues({}, eg), {
      workspaceId: inputPayload
    }));
  }
};
const loadExperimentationGroupsEpicReducer = loadResourcesUtils(loadExperimentationGroupsEpicReducerArgs);
const loadAssignmentUnitsEpicReducerArgs = {
  actionPrefix: `${assignmentUnitsPrefix}V2`,
  reduxKeyNested: () => ["assignmentUnits"],
  loadResource: (workspaceId) => {
    return AssignmentUnitsResource.getAssignmentUnits(workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult.value;
  }
};
const loadAssignmentUnitsEpicReducer = loadResourcesUtils(loadAssignmentUnitsEpicReducerArgs);
const getLoadAssignmentUnitsEpicReducer = () => loadAssignmentUnitsEpicReducer;
const loadRootExperimentationGroupEpicReducerArgs = {
  actionPrefix: rootExperimentationGroupPrefix,
  reduxKeyNested: () => ["rootExperimentationGroup"],
  loadResource: (workspaceId) => {
    return DataplaneResource.getRootExperimentationGroup(workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadRootExperimentationGroupEpicReducer = loadResourcesUtils(loadRootExperimentationGroupEpicReducerArgs);
const loadAnalysisTemplatesEpicReducerArgs = {
  actionPrefix: analysisTemplatesPrefix,
  reduxKeyNested: () => ["analysisTemplates"],
  loadResource: (workspaceId) => {
    return AnalysisTemplateResource.getAnalysisTemplatesNames(workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadAnalysisTemplatesEpicReducer = loadResourcesUtils(loadAnalysisTemplatesEpicReducerArgs);
const loadAnalysisRuleEpicReducerInputArg = {
  actionPrefix: analysisRulePrefix,
  reduxKeyNested: () => ["analysisRule"],
  loadResource: (inputPayload) => DataplaneResource.getAnalysisRule(inputPayload.workspaceId, inputPayload.analysisRuleName),
  onCompleteSuccess: (result) => result
};
const loadAnalysisRuleEpicReducer = loadResourcesUtils(loadAnalysisRuleEpicReducerInputArg);
const editAnalysisRuleEpicReducerInputArg = {
  actionPrefix: editAnalysisRulePrefix,
  reduxKeyNested: () => ["editAnalysisRule"],
  loadResource: (inputPayload) => DataplaneResource.createOrUpdateAnalysisRule(
    inputPayload.workspaceId,
    inputPayload.analysisRuleName,
    inputPayload.analysisRule
  ),
  onCompleteSuccess: (result) => {
    NavigationService.navigateTo(AnalysisConfigRouteUtils.routes.list.url());
    return result;
  }
};
const editAnalysisRuleEpicReducer = loadResourcesUtils(editAnalysisRuleEpicReducerInputArg);
const Edit_epics = combineEpics(
  loadExperimentationGroupsEpicReducer.epic,
  loadRootExperimentationGroupEpicReducer.epic,
  loadAnalysisRuleEpicReducer.epic,
  editAnalysisRuleEpicReducer.epic,
  loadAssignmentUnitsEpicReducer.epic,
  loadAnalysisTemplatesEpicReducer.epic
);
export {
  CLEAR_ANALYSIS_RULE_EDIT_ACTION,
  analysisRulePrefix,
  analysisTemplatesPrefix,
  assignmentUnitsPrefix,
  clearEditAnalysisRule,
  Edit_epics as default,
  editAnalysisRuleEpicReducer,
  editAnalysisRulePrefix,
  experimentationGroupsPrefix,
  getLoadAssignmentUnitsEpicReducer,
  loadAnalysisRuleEpicReducer,
  loadAnalysisTemplatesEpicReducer,
  loadAssignmentUnitsEpicReducer,
  loadExperimentationGroupsEpicReducer,
  loadRootExperimentationGroupEpicReducer,
  prefix,
  rootExperimentationGroupPrefix
};
//# sourceMappingURL=Edit.epics.js.map
